import Cookies from "js-cookie";
import { UserDTO } from "../domain/models/dto/UserDTO";
import { CookieKeys } from "../domain/enums/CookieKeysEnum";
import { LocationServiceImpl } from "./LocationServiceImpl";

export class CookieServiceImpl {
    static setUserLocation(user: UserDTO): void {
        if (!user.allowGeo) {
            return Cookies.remove(CookieKeys.GEO);
        }

        LocationServiceImpl.getClientPosition().then((coords) => {
            if (coords) {
                Cookies.set(CookieKeys.GEO, JSON.stringify(coords), {
                    secure: true,
                });
            } else {
                Cookies.remove(CookieKeys.GEO);
            }
        });
    }
}
